
import { PullRefresh } from "vant";
Vue.use(PullRefresh);
import { Component, Vue } from "vue-property-decorator";
@Component({
  components: {},
})
export default class Logout extends Vue {
  public list = [
    {
      name: "我的收藏",
      icon: require("@/assets/img/my/ICONh5交易行我的收藏.png"),
      path: "/favorite",
    },
    {
      name: "我的货架",
      icon: require("@/assets/img/my/ICONh5交易行我的货架.png"),
      path: "/shelves",
    },
    {
      name: "我要卖",
      icon: require("@/assets/img/my/ICONh5交易行我要卖.png"),
      path: "/wanttoSell",
    },
    {
      name: "指定我",
      icon: require("@/assets/img/my/ICONh5交易行我要卖.png"),
      path: "/appoint",
    },
    {
      name: "交易行规则",
      icon: require("@/assets/img/my/ICONh5交易行交易行规则.png"),
      path: "/regular",
    },
    {
      name: "意见反馈",
      icon: require("@/assets/img/my/ICONh5交易行意见反馈.png"),
      path: "/Feedback",
    },
  ];
}
